<template>
  <router-view />
</template>
<script>

export default {
  name: 'auth-layout',
  components: {
  }
}
</script>